// featured-carousel.js

export default function initializeFeaturedCarousel() {
    const carousel = document.querySelector(".custom-carousel");
    if (!carousel) return;

    const wrapper = carousel.querySelector(".custom-carousel-wrapper");
    const slides = Array.from(wrapper.children);
    const paginationContainer = carousel.querySelector(".custom-carousel-pagination");

    let currentIndex = 0;
    let direction = 1; //
    let autoplayTimeout = null;
    const SLIDE_PAUSE = 4000; 

    function createPagination() {
        paginationContainer.innerHTML = "";
        slides.forEach((_, index) => {
            const button = document.createElement("button");
            button.classList.add("pagination-button");
            button.textContent = index + 1;
            button.addEventListener("click", () => {
                currentIndex = index;
                updateCarousel();
                resetAutoplay();
            });
            paginationContainer.appendChild(button);
        });
    }

    function updatePagination() {
        const buttons = Array.from(paginationContainer.children);
        buttons.forEach((btn, idx) => {
            btn.classList.toggle("active", idx === currentIndex);
        });
    }

    function updateCarousel() {
        const slideWidth = slides[0].getBoundingClientRect().width;
        wrapper.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
        updatePagination();
    }

    function moveSlide() {
        currentIndex += direction;
        if (currentIndex >= slides.length - 1) {
            currentIndex = slides.length - 1;
            direction = -1;
        }
        else if (currentIndex <= 0) {
            currentIndex = 0;
            direction = 1;
        }
        updateCarousel();
    }

    function scheduleNextSlide() {
        autoplayTimeout = setTimeout(() => {
            moveSlide();
            scheduleNextSlide();
        }, SLIDE_PAUSE);
    }

    function startAutoplay() {
        scheduleNextSlide();
    }

    function stopAutoplay() {
        clearTimeout(autoplayTimeout);
    }

    function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
    }

    createPagination();
    updateCarousel();
    startAutoplay();

    carousel.addEventListener("mouseenter", stopAutoplay);
    carousel.addEventListener("mouseleave", startAutoplay);
}
